import React from "react";
import styles from "./link.module.scss";
import { Link as NavLink, useLocation } from "react-router-dom";

type Props = {
  to?: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
  navIcon?: React.ReactNode;
  href?: string;
  target?: string;
  onClick?: (e?: any) => void;
  className?: string;
  comingSoon?: boolean;
  onMouseOver?: (e?: any) => void;
  onMouseLeave?: (e?: any) => void;
};

function MenuLink({
  children,
  to,
  icon,
  navIcon,
  href,
  target,
  onClick,
  onMouseOver,
  onMouseLeave,
  className,
  comingSoon = false,
}: Props) {
  const { pathname } = useLocation();

  const active = pathname === to;

  return (
    <div className={styles.otherWrapper}>
      {!!href ? (
        <a
          onClick={onClick}
          className={`${styles.rightLabel} ${active ? styles.active : ""} ${
            className || ""
          }`}
          href={href}
          target={target}
          onMouseOver={onMouseOver}
          onMouseLeave={onMouseLeave}
        >
          {icon && <div className={styles.menuLeftIcon}>{icon}</div>}
          {children}
          {navIcon && <div className={styles.menuRightIcon}>{navIcon}</div>}
        </a>
      ) : !!to ? (
        <NavLink
          onClick={onClick}
          className={`${styles.rightLabel} ${active ? styles.active : ""} ${
            className || ""
          }`}
          to={to || ""}
          onMouseOver={onMouseOver}
          onMouseLeave={onMouseLeave}
        >
          {icon && <div className={styles.menuLeftIcon}>{icon}</div>}
          {children}
          {navIcon && <div className={styles.menuRightIcon}>{navIcon}</div>}
        </NavLink>
      ) : (
        <div
          onClick={onClick}
          className={`${styles.rightLabel} ${active ? styles.active : ""} ${
            className || ""
          }`}
          onMouseOver={onMouseOver}
          onMouseLeave={onMouseLeave}
          style={{ cursor: comingSoon ? "default" : "pointer" }}
        >
          {icon && <div className={styles.menuLeftIcon}>{icon}</div>}
          {children}
          {navIcon && <div className={styles.menuRightIcon}>{navIcon}</div>}
        </div>
      )}
    </div>
  );
}

export default MenuLink;
